// src/pages/Faq.js
import React from 'react';
import { Accordion, Container } from 'react-bootstrap';
import { FaQuestionCircle } from 'react-icons/fa';

const faqItems = [
  {
    pergunta: 'Como posso fazer parte da equipe?',
    resposta: 'Você pode entrar em contato com a gente. Estaremos felizes em responder!',
  },
  {
    pergunta: 'Onde acontecem os treinos?',
    resposta: 'Nossos treinos são realizados no Centro Esportivo Ssantos Dumont de segunda a sexta.',
  },
  {
    pergunta: 'Como posso doar para a equipe?',
    resposta: 'Aceitamos doações via PIX, transferência bancária ou presencialmente. Entre em contato".',
  },
  {
    pergunta: 'A equipe é aberta a todas as idades?',
    resposta: 'Sim! Temos categorias para várias faixas etárias, desde o infantil até o máster.',
  },
];

function Faq() {
  return (
     <div
      style={{
        background: 'linear-gradient(to right, #f8f9fa, #e0eafc)',
        minHeight: '100vh',
        paddingTop: '40px',
        paddingBottom: '60px',
      }}
    >
    <Container className="my-5">
      <h2 className="text-center mb-4" style={{ fontWeight: 'bold', color: '#333' }}>
        Perguntas Frequentes
      </h2>
      <Accordion flush alwaysOpen>
        {faqItems.map((item, index) => (
          <Accordion.Item
            key={index}
            eventKey={index.toString()}
            style={{
              border: '1px solid #ddd',
              borderRadius: '8px',
              marginBottom: '10px',
              boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
              overflow: 'hidden',
            }}
          >
            <Accordion.Header style={{ backgroundColor: '#f9f9f9', padding: '1rem' }}>
              <FaQuestionCircle className="me-2 text-warning" /> {item.pergunta}
            </Accordion.Header>
            <Accordion.Body style={{ backgroundColor: '#fff', fontSize: '1rem', color: '#444' }}>
              {item.resposta}
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </Container>
    </div>
  );
}

export default Faq;
